export default __webpack_public_path__ + "static/media/langusty_thumb.3f95963d.jpg";